<div
  *ngIf="offerId"
  class="d-flex flex-column gap-4 h-100"
>
  <base-customer-work-council-response-buttons
    *ngIf="isWorkCouncil"
    [workCouncilStatus]="workCouncilStatus"
    (statusChange)="onStatusChange($event)"
  ></base-customer-work-council-response-buttons>

  <base-button
    color="primary"
    label="workCouncil.offers.viewOfferedDays"
    (btnClick)="downloadOfferedDaysFile(true)"
  ></base-button>

  <base-customer-work-council-comments
    class="d-flex flex-column overflow-scroll h-100"
    [offerId]="offerId"
  ></base-customer-work-council-comments>
</div>

<ng-template #changeStatusConfirmModal>
  <base-customer-change-status-confirmation-modal
    [modalRef]="approveDisapproveModalRef"
    [selectedStatus]="selectedStatus"
    [profileFullName]="profileFullName"
  ></base-customer-change-status-confirmation-modal>
</ng-template>

<ng-template #documentViewerTemplate>
  <base-document-viewer
    [fileName]="'workCouncil.offers.offeredDays' | translate"
    [src]="activeDocumentSrc"
    [fileType]="baseFileExtension.pdf"
    [modalRef]="documentViewerModalRef"
    [isCustomBodyText]="true"
    [customBodyText]="documentViewerBodyText | translate: documentViewerBodyTextTranslateParams"
    (downloadImage)="downloadOfferedDaysFile(false)"
  ></base-document-viewer>
</ng-template>
